import { Component, OnInit, computed, inject } from '@angular/core';
import { RouterLink } from '@angular/router';

import { AppDataService } from '../../core/services/app-data.service';
import { DashboardService } from '../../core/services/dashboard.service';
import { ReportService } from '../../core/services/report.service';
import { ExportService } from '../../core/services/export.service';
import { formatCurrency, formatDate } from '../../core/utils/format.util';
import { environment } from '../../environments/environment';
import { ReportDateRangeComponent } from '../report-date-range/report-date-range.component';
import { ReportDateRangeService } from '../../report-date-range.service';

@Component({
  selector: 'app-funeral-usage-report',
  standalone: true,
  imports: [RouterLink, ReportDateRangeComponent],
  templateUrl: './funeral-usage.component.html',
  styleUrl: '../../report-shared.css',
})
export class FuneralUsageReportComponent implements OnInit {
  private readonly appData = inject(AppDataService);
  private readonly reports = inject(ReportService);
  private readonly dashboard = inject(DashboardService);
  private readonly exporter = inject(ExportService);
  protected readonly dateRange = inject(ReportDateRangeService);
  protected readonly formatCurrency = formatCurrency;
  protected readonly formatDate = formatDate;

  private readonly range = computed(() => ({
    startDate: this.dateRange.appliedStartDate(),
    endDate: this.dateRange.appliedEndDate(),
  }));

  protected readonly entries = computed(() =>
    this.reports.getCaseUsage(this.range()),
  );

  protected readonly totalItems = computed(() =>
    this.entries().reduce((sum, entry) => sum + entry.itemsIssued, 0),
  );

  protected readonly totalValue = computed(() =>
    this.entries().reduce((sum, entry) => sum + entry.totalValue, 0),
  );

  ngOnInit(): void {
    if (!environment.useMockData) {
      this.appData.refreshAll();
    }
  }

  exportData(): void {
    this.exporter.downloadCsv(
      `case-usage-${new Date().toISOString().slice(0, 10)}`,
      this.entries().map((row) => ({ ...row })),
    );
  }
}
